import { render, staticRenderFns } from "./CertificationNameCell.vue?vue&type=template&id=1823cdd1&scoped=true"
import script from "./CertificationNameCell.vue?vue&type=script&lang=js"
export * from "./CertificationNameCell.vue?vue&type=script&lang=js"
import style0 from "./CertificationNameCell.vue?vue&type=style&index=0&id=1823cdd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1823cdd1",
  null
  
)

export default component.exports